/**
 * Pre-compiled pt-BR messages for LoadingSpinner
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { default: `Carregando dados` };
